export const TRAINING_HALF_DAY_AMOUNT = 422;
